import { TYPES } from './actions';

export const popupInitialState = {
    isGatedMeasureNoticePopupOpen: false,
    isGradeNotAvailablePopupOpen: false,
    isD8AlternateFormSelectionPopupOpen: false,
    isLecturaAltFormSelectionPopupOpen: false,
    isVocAssessNoticePopupOpen: false,
    isCSFormSelectionPopupOpen: false,
    isBurstAltFormSelectionPopupOpen: false,
    isPMFormSelectionPopupOpen: false,
    isMazeScorePopupOpen: false,
    isCPScorePopupOpen: false,
    isAINoDetailsAvailablePopupOpen: false,
    isLecturaNoDetailsAvailablePopupOpen: false,
    isNoResultDetailsPopupOpen: false,
    isUnofficialResultPopupOpen: false,
    isCreatePresumedResultPopupOpen: false,
    isDeletePresumedResultPopupOpen: false,
    isOrfG5BoyFormPopupOpen: false,
    isOrfG5PMForm1AltTextPopupOpen: false,
    isDigitalFormsPopupOpen: false,
    isTRCOutsideBMPopupOpen: false,
    isNoIDELSupportPopupOpen: false,
    userPopupsSettings: {
        isOrfG5BoyFormPopupEnable: true,
        isDigitalPopupEnabled: true,
    },
    params: {},
};

export const popupReducer = (state = popupInitialState, { type, payload }) => {
    switch (type) {
        case TYPES.SHOW_GATED_MEASURE_NOTICE_POPUP:
            return {
                ...state,
                params: payload,
                isGatedMeasureNoticePopupOpen: true,
            };
        case TYPES.HIDE_GATED_MEASURE_NOTICE_POPUP:
            return {
                ...state,
                isGatedMeasureNoticePopupOpen: false,
                params: {},
            };
        case TYPES.SHOW_GRADE_NOT_AVAILABLE_POPUP:
            return {
                ...state,
                params: payload,
                isGradeNotAvailablePopupOpen: true,
            };
        case TYPES.HIDE_GRADE_NOT_AVAILABLE_POPUP:
            return {
                ...state,
                params: {},
                isGradeNotAvailablePopupOpen: false,
            };
        case TYPES.SHOW_D8_ALTERNATE_FORM_SELECTION_POPUP:
            return {
                ...state,
                params: payload,
                isD8AlternateFormSelectionPopupOpen: true,
            };
        case TYPES.HIDE_D8_ALTERNATE_FORM_SELECTION_POPUP:
            return {
                ...state,
                params: {},
                isD8AlternateFormSelectionPopupOpen: false,
            };
        case TYPES.SHOW_LECTURA_ALT_FORM_SELECTION_POPUP:
            return {
                ...state,
                params: payload,
                isLecturaAltFormSelectionPopupOpen: true,
            };
        case TYPES.HIDE_LECTURA_ALT_FORM_SELECTION_POPUP:
            return {
                ...state,
                params: {},
                isLecturaAltFormSelectionPopupOpen: false,
            };
        case TYPES.SHOW_VOC_ASSESS_NOTICE_POPUP:
            return {
                ...state,
                params: payload,
                isVocAssessNoticePopupOpen: true,
            };
        case TYPES.HIDE_VOC_ASSESS_NOTICE_POPUP:
            return {
                ...state,
                isVocAssessNoticePopupOpen: false,
                params: {},
            };
        case TYPES.SHOW_CS_FORM_SELECTION_POPUP:
            return {
                ...state,
                params: payload,
                isCSFormSelectionPopupOpen: true,
            };
        case TYPES.HIDE_CS_FORM_SELECTION_POPUP:
            return {
                ...state,
                isCSFormSelectionPopupOpen: false,
                params: {},
            };
        case TYPES.SHOW_BURST_ALT_FORM_SELECTION_POPUP:
            return {
                ...state,
                params: payload,
                isBurstAltFormSelectionPopupOpen: true,
            };
        case TYPES.HIDE_BURST_ALT_FORM_SELECTION_POPUP:
            return {
                ...state,
                isBurstAltFormSelectionPopupOpen: false,
                params: {},
            };
        case TYPES.SHOW_PM_FORM_SELECTION_POPUP:
            return {
                ...state,
                params: payload,
                isPMFormSelectionPopupOpen: true,
            };
        case TYPES.HIDE_PM_FORM_SELECTION_POPUP:
            return {
                ...state,
                isPMFormSelectionPopupOpen: false,
                params: {},
            };
        case TYPES.SHOW_MAZE_SCORE_POPUP:
            return {
                ...state,
                isMazeScorePopupOpen: true,
            };
        case TYPES.HIDE_MAZE_SCORE_POPUP:
            return {
                ...state,
                isMazeScorePopupOpen: false,
            };
        case TYPES.SHOW_CP_SCORE_POPUP:
            return {
                ...state,
                isCPScorePopupOpen: true,
            };
        case TYPES.HIDE_CP_SCORE_POPUP:
            return {
                ...state,
                isCPScorePopupOpen: false,
            };
        case TYPES.SHOW_AI_NO_DETAILS_AVAILABLE_POPUP_POPUP:
            return {
                ...state,
                isAINoDetailsAvailablePopupOpen: true,
            };
        case TYPES.HIDE_AI_NO_DETAILS_AVAILABLE_POPUP_POPUP:
            return {
                ...state,
                isAINoDetailsAvailablePopupOpen: false,
            };
        case TYPES.SHOW_LECTURA_NO_DETAILS_AVAILABLE_POPUP:
            return {
                ...state,
                isLecturaNoDetailsAvailablePopupOpen: true,
            };
        case TYPES.HIDE_LECTURA_NO_DETAILS_AVAILABLE_POPUP:
            return {
                ...state,
                isLecturaNoDetailsAvailablePopupOpen: false,
            };
        case TYPES.SHOW_NO_RESULT_DETAILS_POPUP:
            return {
                ...state,
                params: payload,
                isNoResultDetailsPopupOpen: true,
            };
        case TYPES.SHOW_UNOFFICIAL_RESULT_POPUP:
            return {
                ...state,
                params: payload,
                isUnofficialResultPopupOpen: true,
            };
        case TYPES.HIDE_OFFICIALNESS_POPUP:
            return {
                ...state,
                isUnofficialResultPopupOpen: false,
                isNoResultDetailsPopupOpen: false,
            };
        case TYPES.SHOW_CREATE_PRESUMED_RESULT_POPUP:
            return {
                ...state,
                params: payload,
                isCreatePresumedResultPopupOpen: true,
            };
        case TYPES.HIDE_CREATE_PRESUMED_RESULT_POPUP:
            return {
                ...state,
                params: popupInitialState.params,
                isCreatePresumedResultPopupOpen: false,
            };
        case TYPES.SHOW_DELETE_PRESUMED_RESULT_POPUP:
            return {
                ...state,
                params: payload,
                isDeletePresumedResultPopupOpen: true,
            };
        case TYPES.HIDE_DELETE_PRESUMED_RESULT_POPUP:
            return {
                ...state,
                params: popupInitialState.params,
                isDeletePresumedResultPopupOpen: false,
            };
        case TYPES.SHOW_NO_DETAILS_AVAILABLE_POPUP:
            return {
                ...state,
                isNoDetailsAvailablePopupVisible: true,
            };
        case TYPES.HIDE_NO_DETAILS_AVAILABLE_POPUP:
            return {
                ...state,
                isNoDetailsAvailablePopupVisible: false,
            };
        case TYPES.SHOW_ORF_G5_BOY_FORM_POPUP:
            return {
                ...state,
                params: payload,
                isOrfG5BoyFormPopupOpen: true,
            };
        case TYPES.HIDE_ORF_G5_BOY_FORM_POPUP:
            return {
                ...state,
                isOrfG5BoyFormPopupOpen: false,
                params: {},
            };
        case TYPES.ENABLE_VISIBILITY_ORF_G5_BOY_FORM_POPUP:
            return {
                ...state,
                userPopupsSettings: {
                    ...state.userPopupsSettings,
                    isOrfG5BoyFormPopupEnable: payload,
                },
            };
        case TYPES.SHOW_ORF_G5_PM_FORM1_ALT_TEXT_POPUP:
            return {
                ...state,
                params: payload,
                isOrfG5PMForm1AltTextPopupOpen: true,
            };
        case TYPES.HIDE_ORF_G5_PM_FORM1_ALT_TEXT_POPUP:
            return {
                ...state,
                isOrfG5PMForm1AltTextPopupOpen: false,
                params: {},
            };
        case TYPES.SHOW_DIGITAL_FORMS_POPUP:
            return {
                ...state,
                params: payload,
                isDigitalFormsPopupOpen: true,
            };
        case TYPES.HIDE_DIGITAL_FORMS_POPUP:
            return {
                ...state,
                isDigitalFormsPopupOpen: false,
                params: {},
            };
        case TYPES.ENABLE_VISIBILITY_DIGITAL_FORMS_POPUP:
            return {
                ...state,
                userPopupsSettings: {
                    ...state.userPopupsSettings,
                    isDigitalPopupEnabled: payload,
                },
            };
        case TYPES.SHOW_TRC_OUTSIDE_BM_POPUP:
            return {
                ...state,
                params: payload,
                isTRCOutsideBMPopupOpen: true,
            };
        case TYPES.HIDE_TRC_OUTSIDE_BM_POPUP:
            return {
                ...state,
                isTRCOutsideBMPopupOpen: false,
                params: {},
            };
        case TYPES.SHOW_NO_IDEL_SUPPORT_POPUP:
            return {
                ...state,
                isNoIDELSupportPopupOpen: true,
            };
        case TYPES.HIDE_NO_IDEL_SUPPORT_POPUP:
            return {
                ...state,
                isNoIDELSupportPopupOpen: false,
            };
        default:
            return state;
    }
};

export default popupReducer;
